/** * https://www.npmjs.com/package/vue-radial-progress */
<template>
  <div class="progress-ring-wrapper">
    <div class="ring">
      <radial-progress-bar
        :diameter="130"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :strokeWidth="10"
        :innerStrokeWidth="10"
        :startColor="startColor"
        :stopColor="stopColor"
        :innerStrokeColor="innerStrokeColor"
        strokeLinecap="butt"
        :animateSpeed="250"
      />
    </div>
    <div :class="cls">
      <span>{{ percent }}%</span>
    </div>
  </div>
</template>
<script>
import RadialProgressBar from "vue-radial-progress";
export default {
  props: ["completedSteps", "totalSteps"],
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      startColor: "rgb(255,102,0)",
      stopColor: "rgb(255,102,0)",
      innerStrokeColor: "rgba(225,225,225,1)",
    };
  },
  computed: {
    percent: function () {
      var num =
        (parseInt(this.completedSteps) / parseInt(this.totalSteps)) * 100;
      return Math.round(num);
    },
    cls: function () {
      if (this.percent == 100) {
        return "percent complete";
      } else {
        return "percent";
      }
    },
  },
};
</script>
<style lang="scss">
.progress-ring-wrapper {
  max-width: 130px;
  max-height: 130px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .ring {
    position: absolute;
    top: 0;
    left: 0;
  }

  .percent {
    display: flex;
    font-size: 1.2em;
    justify-content: center;
    align-items: center;
    background: #fff;
    width: 100px;
    height: 100px;
    border-radius: calc(50% + 10px);
    z-index: 9999;
    color: #777;
    transition: all 100ms ease-in;
    &.complete,
    &:hover {
      width: 110px;
      height: 110px;
      color: rgb(255, 102, 0);
      font-size: 1.5em;
    }

    span {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
